<ng-container *transloco="let t">
  <app-lex-xi-side-panel
    [isLoading]="false"
    [selectedItem]="selectedUser"
    [rightPlaceholder]="usersRightPlaceholder"
    [verticalTabBarData]="[
      {
        id: 'account',
        icon: 'account',
        hint: t('user-list.users'),
        hasSeparator: true,
        leftSideTemplate: userList,
        rightSideTemplate: userDetails,
      },
      {
        id: 'reports',
        icon: 'document_report',
        hint: t('user-list.reports'),
        hasSeparator: true,
        rightSideTemplate: reportDetails,
        adminOnly: true,
      },
      {
        id: 'credit-usage',
        icon: 'receipt',
        hint: t('credit-usage.credit-usage'),
        hasSeparator: true,
        rightSideTemplate: usageDetails,
        adminOnly: true,
      },
    ]"
  ></app-lex-xi-side-panel>

  <ng-template #userList>
    <app-user-list [isAdmin]="isAdmin"></app-user-list>
  </ng-template>

  <ng-template #userDetails>
    @if (selectedUser) {
      <app-user-details
        [user]="selectedUser"
        [userList]="userList"
        [isLoading]="isViewLoading"
        [isAdmin]="isAdmin"
        (permissionChanged)="refreshUsers()"
        (groupRemoved)="refreshUsers()"
        (reloadUser)="onReloadUser()"
        (deleteUser)="onDeleteUser($event)"
      ></app-user-details>
    }
  </ng-template>

  <ng-template #reportDetails>
    <app-reports></app-reports>
  </ng-template>

  <ng-template #usageDetails>
    <credit-usage></credit-usage>
  </ng-template>
</ng-container>
